import * as React from 'react';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { UploadInputWrapper } from 'client/ui/form/input/UploadInputWrapper';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { Button, Typography } from 'antd';
const { Text, Paragraph } = Typography;
import { VerticalSpace } from 'client/ui/space/VerticalSpace';
import { WidgetUploadSignedInput } from './upload/WidgetUploadSignedInput';
import { WidgetInputUploadSignedText } from '../helper/WidgetInputUploadSignedText';
import { DownloadPdfButton } from '../helper/DownloadPdfButton';
import { WidgetPreviewDownloader } from './upload-signed/WidgetPreviewDownloader';

export interface FormWidgetInputPreviewViewProps {
  widget: IWidget;
}

export function FormWidgetInputPreviewView(
  props: FormWidgetInputPreviewViewProps
) {
  const { widget } = props;

  const buttonText = widget.input!.extra?.downloadButton;
  const documentId = widget.input!.extra?.documentId;

  const colProps = {
    // labelCol: { span: 6 },
    wrapperCol: { span: 18, offset: 6 },
    label: null
  };

  return (
    <div className="widget-segned-file-wrapper">
      <FormWidgetItem names={[]} widget={widget} {...colProps}>
        <UploadInputWrapper>
          <VerticalSpace size={10} />
          <WidgetInputUploadSignedText previewOnly={true} />
          <VerticalSpace size={10} />
          <WidgetPreviewDownloader
            procedureId={widget.procedureId}
            buttonText={buttonText}
            documentId={documentId}
          />
          <VerticalSpace />
        </UploadInputWrapper>
      </FormWidgetItem>
    </div>
  );
}
